module.exports = __webpack_public_path__ + "assets/img/241401.e98d7edf.png";